/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import Icon from '@mui/icons-material/ExpandLess';
import { IconButton, styleIcon } from './IconButton';
import { IconButtonProps } from './types';

const StyledIcon = styleIcon(Icon);

export const CollapseIconButton = ({
    disabled,
    iconColor,
    ...rest
}: IconButtonProps) => (
    <IconButton disabled={disabled} {...rest}>
        <StyledIcon disabled={disabled} iconColor={iconColor || '#000000'} />
    </IconButton>
);
